import {Knob} from "react-rotary-knob";
import * as skins from "react-rotary-knob-skin-pack";
import React from "react";

const knobstyle = {
    width: "50px",
    height: "50px",
};

const customKnob = ({knobName = "", unlockDistance = 20, value = 0, min = 0, max = 100, preciseMode = false, skin = skins.s12, changeHandler}) => {
    return (
        <>
            <Knob
                style={knobstyle}
                unlockDistance={unlockDistance}
                skin={skin}
                preciseMode={preciseMode}
                min={min}
                max={max}
                value={value}
                onChange={changeHandler}
            />
            <p>{knobName}</p>
        </>
    )
}

export default customKnob